module.exports = __webpack_public_path__ + "img/basic-confused.dd8842d2.svg";